export const PlanData = [
	{
		planCName: "plan",
		type: "Basic",
		feature:
			"Includes basic usage of our platform. Recommended for new and aspiring photographers.",
		priceMonth: "$19.00",
		priceYear: "$190.00",
		timeMonth: "per month",
		timeYear: "per year",
		btnCName: "plan-btn",
	},
	{
		planCName: "plan__pro",
		type: "Pro",
		feature:
			"More advanced features available. Recommended for photography veterans and professionals.",
		priceMonth: "$39.00",
		priceYear: "$390.00",
		timeMonth: "per month",
		timeYear: "per year",
		btnCName: "plan-btn pro",
	},
	{
		planCName: "plan",
		type: "Business",
		feature:
			"Additional features available such as more detailed metrics. Recommended for business owners.",
		priceMonth: "$99.00",
		priceYear: "$990.00",
		timeMonth: "per month",
		timeYear: "per year",
		btnCName: "plan-btn",
	},
];
